module.exports = __webpack_public_path__ + "static/img/news2-cover.00be430.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news2-cover.jpg
// module id = QYcw
// module chunks = 0